import React, { useState, useRef } from "react";
import "./codeInput.css";

const CodeInput = (props: CodeInputType) => {
  const length = props.length || 6;
  const [code, setCode] = useState<string[]>(new Array(length).fill(""));
  const inputs = useRef<(HTMLInputElement | null)[]>([]);

  function updateFormValue(newCodeArray: string[]) {
    const fullString = newCodeArray.join("");

    if (props.onChange) {
      props.onChange(fullString);
    }
    if (props.onComplete && fullString.length === length) {
      props.onComplete(fullString);
    }
  }

  function handleChange(value: string, index: number) {
    if (isNaN(Number(value)) && value !== "") return;

    const newCode = [...code];
    newCode[index] = value.substring(value.length - 1);
    setCode(newCode);
    updateFormValue(newCode);

    if (value && index < length - 1) {
      inputs.current[index + 1]?.focus();
    }
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>, index: number) {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  }

  function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
    const data = e.clipboardData.getData("text").trim().slice(0, length).split("");
    const newCode = [...code];
    data.forEach((char, index) => {
      if (!isNaN(Number(char))) newCode[index] = char;
    });
    setCode(newCode);
    updateFormValue(newCode);

    const nextIndex = data.length < length ? data.length : length - 1;
    inputs.current[nextIndex]?.focus();
  }

  return (
    <div className="code-input-container">
      {code.map((num, idx) => (
        <input
          key={idx}
          ref={(el: any) => (inputs.current[idx] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          autoCorrect="none"
          value={num}
          disabled={props.disabled}
          readOnly={props.readonly}
          onChange={(e) => handleChange(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          onPaste={handlePaste}
          className={`code-input-box `}
          style={props.inputStyle}
        />
      ))}
    </div>
  );
};

export default CodeInput;

export interface CodeInputType {
  length?: number;
  value?: string;
  inputClass?: string;
  inputStyle?: React.CSSProperties;
  name?: string;
  disabled?: boolean;
  readonly?: boolean;
  onChange?: Function;
  onComplete?: Function;
}
